import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';

class SignUpResult extends Component {
  static propTypes = {
    isSuccess: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    ReactGA.pageview('/signup');
  }

  goBackToSignInPage() {
    this.props.history.push('/login');
  }

  renderSubmissionUnsuccessful = () => {
    return (
      <div className="col-6 sign-up-result">
        <div className="title unsuccessful">
          <b>Submission Unsuccessful</b>
          <i className="la la-times icon" />
        </div>
        <p>Your organization already has an account with us!</p>
        <p>
          Please email <b>resonanceadmin@resonance.com</b> for more details.
        </p>
        <button className="btn" onClick={e => this.goBackToSignInPage()}>
          Go back
        </button>
      </div>
    );
  };

  renderSubmissionConfirmed = () => {
    return (
      <div className="col-6 sign-up-result">
        <div className="title success">
          <b>Submission Confirmed</b>
          <i className="la la-check icon" />
        </div>
        <p>Thank you for signing up for our trial!</p>
        <p>Our team will review your application and get back to you soon!</p>
      </div>
    );
  };

  render() {
    return this.props.isSuccess
      ? this.renderSubmissionConfirmed()
      : this.renderSubmissionUnsuccessful();
  }
}

export default SignUpResult;



// WEBPACK FOOTER //
// ./src/features/login/components/SignUpResult.js